import { msalInstance, ensureMsalInitialized } from "@/msalConfig";
import api from "@/utils/api"; // ← 毎回 silent でトークン付与する共通 Axios
import router from "@/router";
import { useAuthStore } from "@/stores/authStore";
import { pinia } from "@/piniaInstance";

const authStore = useAuthStore(pinia);
const { isAuthenticated, userId, userName, houseId } = authStore;

/**
 * バックエンドへのログアウト通知（タイムアウト付き）
 * Authorization は api のリクエスト・インターセプターが自動付与
 */
async function postLogoutToBackend() {
	const controller = new AbortController();
	const timeoutId = setTimeout(() => controller.abort(), 5000);
	try {
		await api.post(
			"", // baseURL のルートに対して
			{}, // body は空（必要なら付与）
			{
				params: { action: "Logout" }, // 既存 API 仕様に合わせたクエリ
				signal: controller.signal,
				headers: { "Content-Type": "application/json" }, // Authorization は自動
				cache: "no-store",
			}
		);
		// 成功時のステータス（例：204）をチェックしたい場合はここで検証
	} catch (e) {
		console.warn("Logout API error:", e);
		// 失敗しても MSAL の logout は続行（ネットワーク遮断等で API 通知が落ちるケースのため）
	} finally {
		clearTimeout(timeoutId);
	}
}

/**
 * アプリ全体ログアウト
 * 処理順：
 * 1) MSAL initialize 保証
 * 2) バックエンドのセッション失効（api 経由：毎回 silent）
 * 3) MSAL logoutRedirect（Entra セッション終了）
 * 4) 例外時のみフロント状態クリア＋トップへ遷移
 */
export async function logout() {
	// 1) 初期化保証
	await ensureMsalInitialized();
	// 2) バックエンド側セッション終了（Authorization は api 側で毎回 silent 付与）
	await postLogoutToBackend();
	// 3) MSAL ログアウト（通常ここでブラウザ遷移が発生）
	try {
		const active = msalInstance.getActiveAccount();
		const account = active || (userId?.value ? msalInstance.getAccountByHomeId(userId.value) : undefined);
		await msalInstance.logoutRedirect({ account });
	} catch (e) {
		console.warn("MSAL logoutRedirect failed:", e);
		// 4) フォールバック：フロント状態クリア＋トップへ
		try {
			isAuthenticated.value = false;
			userId.value = "";
			userName.value = "";
			houseId.value = "";
			sessionStorage.clear();
			await router.replace("/");
		} catch (navErr) {
			console.warn("Router replace failed after logout:", navErr);
		}
	}
}
